// <copyright file="common-confirm-dialog.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 12/10/2025 by Pankaj Mishra
// </copyright>

import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";
import { CommonConfirmDialog, ConfirmDialogAdditionalData } from "./common-confirm-dialog.model";
@Component({
  selector: "app-common-confirm-dialog",
  imports: [MatDialogModule, MatDialogTitle, MatDialogContent, MatButtonModule, TranslatePipe],
  templateUrl: "./common-confirm-dialog.html",
  styleUrl: "./common-confirm-dialog.scss"
})
// Defines CommonConfirmDialogComponent.
export class CommonConfirmDialogComponent {
  public dialogRef = inject(MatDialogRef<CommonConfirmDialogComponent>);
  public data = inject<CommonConfirmDialog>(MAT_DIALOG_DATA);
  public additionalData = inject<ConfirmDialogAdditionalData>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }
  onCancle(): void {
    this.dialogRef.close(false);
  }
}
